/* eslint-disable max-len */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const CommentIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 16.934 16.934' className={className}>
    <path
      id='Label'
      d='M0,2.49A8.53,8.53,0,0,0,8.467-5.977,8.531,8.531,0,0,0-.008-14.443,8.522,8.522,0,0,0-8.467-5.977,8.535,8.535,0,0,0,0,2.49ZM0-10.376c2.673,0,4.781,1.751,4.781,3.9S2.673-2.557,0-2.557c-.183,0-.374-.017-.531-.025a.355.355,0,0,0-.232.075,6.094,6.094,0,0,1-2.2.888c-.382,0-.465-.307-.216-.589a4.21,4.21,0,0,0,.573-.747c.05-.1.058-.191-.05-.249A3.937,3.937,0,0,1-4.781-6.475C-4.781-8.625-2.673-10.376,0-10.376Z'
      transform='translate(8.467 14.443)'
      fill='#0085ff'
    />
  </SvgIcon>
);

export default CommentIcon;
